import { render } from "./WCValidationMessage.vue?vue&type=template&id=04994914"
import script from "./WCValidationMessage.vue?vue&type=script&lang=js"
export * from "./WCValidationMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__